<template>
  <div>
    <!-- <v-btn
      color="primary"
      dark
      @click="openModal"
    >
      {{ $t("add_new") }}
    </v-btn> -->
    <v-btn
      color="primary"
      dark
      title="Assigned of Product Type"
      style="min-width: 30px; max-width: 45px"
      @click="openModal"
    >
      <v-icon>mdi-link</v-icon>
    </v-btn>


    <!-- v-if="isVisibleDialog" -->
    <v-dialog
      v-model="isVisibleDialog"
      persistent
      max-width="950px"
    >
      <v-form
        ref="form"
        lazy-validation
      >
        <v-card>
          <v-card-title>
            <span class="text-h3">Assign Product Type</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="options.tier"
                    dense
                    :items="productTierslist"
                    item-value="id"
                    item-text="name"
                    :label="$t('select_tier_*')"
                    :rules="[rules.required]"
                  />
                </v-col>
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="options.product"
                    dense
                    :items="productList"
                    item-value="id"
                    item-text="name"
                    :label="$t('select_product_*')"
                    :rules="[rules.required]"
                  />
                </v-col>
                <!-- <v-col
                  cols="12"
                  sm="6"
                >
                  <v-autocomplete
                    v-model="options.permissionIds"
                    dense
                    :items="permissionsList"
                    item-value="id"
                    item-text="name"
                    :label="$t('permission_*')"
                    multiple
                    :rules="[rules.required]"
                  />
                </v-col> -->
                <v-col
                  cols="12"
                  sm="6"
                >
                  <v-select
                    v-model="options.is_active"
                    dense
                    :items="statusOptions"
                    item-value="id"
                    item-text="name"
                    :label="$t('status_*')"
                    :rules="[rules.required]"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <small>{{ $t("indicates_required_field") }}</small>
            <v-spacer />
            <v-btn
              color="red darken-1"
              text
              @click="closeForm()"
            >
              Close
            </v-btn>
            <v-btn
              color="primary"
              text
              :loading="loading"
              @click="saveItem"
            >
              Assign
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>

import { validationRules } from "@/mixins/validationRules";
import { mapGetters } from "vuex";

export default {
  components: {
  },
  mixins: [validationRules],
  props: {
    filterOptions: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      loading: false,
      isVisibleDialog: false,
      options:{},

      statusOptions:[
        {id:"true", name:"Active"},
        {id:"false", name:"Inactive"}
      ]
    };
  },

  computed: {
    ...mapGetters({
      authUser: "getUser",
      productTierslist: "productTiers/getList",
      productList:"products/getProductList",
      permissionsList: 'permissions/listPermissions',

    }),
  },

  watch: {
    // add any required watchers here
  },

  async mounted() {
    this.$store.dispatch("products/list")
    this.$store.dispatch("permissions/permissionDropDown")
  },

  methods: {
    openModal() {
      this.isVisibleDialog = !this.isVisibleDialog;
    },
    closeForm() {
      this.$refs.form.reset();
      this.isVisibleDialog = false;
    },
    async saveItem() {
      const params = {...this.options}
      params.permission_ids = this.permissionsList.map(r => r.id)
      this.loading = true;
      await this.$store
        .dispatch("productTiers/assign", params)
        .then(() => {
          this.$store.dispatch(
            "alerts/success",
            this.$t("assigned_successfully")
          );
          this.closeForm();
        })
        .catch((error) => {
          this.$store.dispatch("alerts/error", error.response?.data?.message);
        })
        .finally(() => (this.loading = false));
    },
  },
};
</script>
